module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE3IDE0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMy45MTloMi45OTN2NS45N0gwVjMuOTJ6bTIuOTk1LS4wMTVMNyAuOTI0djEyTDIuOTk1IDkuODgydi01Ljk4eiIvPgogICAgICAgIDxwYXRoIHN0cm9rZT0iI0ZGRiIgZD0iTTEyLjc5MyAxMy43MTZhOS42MDcgOS42MDcgMCAwIDAgMC0xMy41ODZNOS44NTMgMTAuODM3YTUuNDUgNS40NSAwIDAgMCAwLTcuNzA3Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/assets/volume/volume-100.svg
// module id = 1688
// module chunks = 1 2 3